<template>
  <ku-dialog
    width="900px !important"
    :title="title || $t('选择设备')"
    v-bind="$props"
    v-on="new$listeners"
  >
    <div class="device-selector d-flex">
      <div class="left_block">
        <ku-vertical-selector
          ref="groupSelector"
          v-loading="loadingGroup"
          size="small"
          node-key="id"
          :need-header="false"
          :enable-search="false"
          :display-type="selectType"
          :tabs-list="tabsList"
          :data-list.sync="selectGroupList"
          :checked-list.sync="selectedGroupOpt"
          :is-tree-check-strictly="true"
          tree-parent-icon="iconsimple icon-s-chejian"
          tree-leaf-icon="iconsimple icon-s-shebei"
          @on-tab-change="onTabChange"
          @option-click="onSelectGourp"
        />
      </div>

      <div class="midddle-block">
        <ku-input v-model="searchVal" class="midddle-block_search" with-search="default" @submit="searchDevice" />
        <div v-loading="loadingDevice" style="flex: 1; overflow: hidden;">
          <el-scrollbar v-if="filteredDevices.length" ref="deviceScroller" class="midddle-block_area">
            <template>
              <div class="device-box d-flex">
                <div
                  v-for="i in filteredDevices"
                  :key="i.id"
                  class="d-flex align-center device-item"
                  :class="{ 'device-item-cli': deviceId === i.id, 'device-showstatus': showStatusFlag }"
                  @click="handleDeviceClick(i)"
                  @dblclick="handleDeviceDblclick(i)"
                >
                  <!-- 圆点【showStatus为兼容老版本】 -->
                  <div v-show="showStatusFlag" :style="{backgroundColor: deviceStatusMap[i.runStatus || 'null'].barColor}" style="width: 8px; height: 8px; border-radius:50%; margin-right: 8px;"></div>
                  <ku-text-ellipsis :content="i.name" width="auto" />
                </div>
              </div>
            </template>
          </el-scrollbar>
          <ku-empty v-else-if="!loadingDevice" type="2" size="mini" style="height: 100%;" />
        </div>
      </div>
      <div class="right_block">
        <span class="right_block_title">{{ $t('历史选择') }}</span>
        <el-scrollbar v-if="deviceSelectHistoryData.length">
          <span
            v-for="(labelItem, labelIndex) in deviceSelectHistoryData"
            :key="labelIndex"
            class="device-label"
            :class="{active: labelItem.deviceId === deviceId}"
            @click="handleDeviceClick({
              isCached: true,
              id: labelItem.deviceId,
              name: labelItem.deviceName,
              sn: labelItem.sn,
              deviceBrandId: labelItem.deviceBrandId,
              categoryDictCode: labelItem.categoryDictCode,
              categoryDictName: labelItem.categoryDictName,
              spaceName: labelItem.spaceName,
              ...labelItem.deviceInfo
            })"
            @dblclick="handleDeviceDblclick({
              isCached: true,
              id: labelItem.deviceId,
              name: labelItem.deviceName,
              sn: labelItem.sn,
              deviceBrandId: labelItem.deviceBrandId,
              categoryDictCode: labelItem.categoryDictCode,
              categoryDictName: labelItem.categoryDictName,
              spaceName: labelItem.spaceName,
              ...labelItem.deviceInfo
            })"
          >{{ labelItem.deviceName }}</span>
        </el-scrollbar>
        <ku-empty v-else type="2" size="mini" style="height: 100%;" />
      </div>
    </div>

    <div v-if="timeRangeCfg.enable || $slots.expandSlot" class="expand_block">
      <div v-if="timeRangeCfg.enable">
        <ku-form vertical>
          <ku-form-item :label="$t('时间范围选择')" :tips="timeRangeCfg.tip">
            <ku-datetime-picker
              v-model="timeRange"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              use-range
              :range-limit="timeRangeCfg.timeRangeLimit"
              :range-limit-now="timeRangeCfg.rangeLimitNow"
              :range-begin-bind="timeRangeCfg.rangeBeginBind"
              :range-end-bind="timeRangeCfg.rangeEndBind"
              :enable-short-cut="!!timeRangeCfg.enableShortCut"
              :short-cuts="timeRangeCfg.shortCuts || []"
              :extra-short-cut="timeRangeCfg.timeShortcut || []"
              @change="timeRangeCfg.change"
              @on-shortcut-change="onTimeShortcutChange"
            />
          </ku-form-item>
        </ku-form>
      </div>
      <slot name="expandSlot"></slot>
    </div>
  </ku-dialog>
</template>

<script>
import { DEVICE_STATUS_MAP } from '@klinx/ccs/src/config/device/common';
import { ccsDeviceApi } from '@klinx/ccs/src/api/index.js';
import { baseDeviceApi, baseOrgApi } from '@klinx/base/src/api/index.js';
import { axiosAllSettled } from '@klinx/utils';

export default {
  name: 'SelectDevice',
  props: {
    // 组件标记，用于区分缓存
    tag: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: true
    },
    // 是否显示设备状态，保留兼容老版本
    showStatus: {
      type: Boolean,
      default: true
    },
    // 设备空间，保留兼容老版本
    spaceName: {
      type: String,
      default: ''
    },
    isNewColour: {
      type: Boolean,
      default: false
    },
    // 初始设备（name）
    originDevice: {
      type: String,
      default: ''
    },
    // 是否需要过滤可监控设备
    isOnlyMonitor: {
      type: Boolean,
      default: true
    },
    // 是否需要新的选择逻辑（是否过滤数采、是否查状态、自定义查询设备种类）
    useNewSelector: {
      type: Boolean,
      default: false
    },
    // 新的设备查询参数
    newSelectorParams: {
      type: Object,
      // boolMonitor 不传不筛选
      default: () => ({ machine: '', showStatus: false })
    },
    // 设备类型code
    deviceCode: {
      type: Array,
      default: () => ([])
    },
    timeRangeCfg: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      deviceStatusMap: DEVICE_STATUS_MAP,
      activeTab: 'cate',
      tabsList: [{ label: this.$t('类型'), name: 'cate' }, { label: this.$t('区域'), name: 'space' }],
      hasInitOrigin: false, // 是否初始化完
      isUsingCache: false,
      loadingGroup: false,
      selectType: 'list',
      deviceAllData: [], // 全部设备集
      selectGroupList: [], // 类型和区域选择数据集
      selectedGroupOpt: [], // 当前选择的数据集类型
      currentSelected: { // 类型和区域下，当前选择的选项
        cate: null,
        space: null
      },
      deviceCacheMap: {}, // 类型、空间id缓存设备数据
      curDeviceList: [], // 当前选择区域的设备集
      searchVal: '', // 设备搜索关键字
      filteredDevices: [], // 搜索筛选过滤的设备集
      loadingDevice: false,
      // 当前选择设备相关的信息
      deviceId: '',
      deviceName: '',
      deviceSn: '',
      deviceBrandId: '',
      categoryDictCode: '',
      categoryDictName: '',
      selSpaceName: '',
      deviceInfo: {}, // 完整设备信息
      // 历史选择的设备集
      deviceSelectHistoryData: [],
      deviceTypeCode: [], // 外层需要过滤的设备类型
      timeRange: [],
      isSelectCache: false // 是否选择历史设备
    };
  },
  computed: {
    locStorageKey() {
      return `${this.tag}-deviceSelectData`;
    },
    showStatusFlag() {
      if (this.useNewSelector) {
        return !!this.newSelectorParams.showStatus;
      }
      return this.showStatus;
    },
    new$listeners() {
      return {
        ...this.$listeners,
        cancel: this.cancleDevice,
        confirm: this.confirmDevice
      };
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initDeviceList();
        if (localStorage.getItem(this.locStorageKey)) {
          const historyData = JSON.parse(localStorage.getItem(this.locStorageKey));
          const devices = historyData.devices || [];

          // 过滤工序设备类型
          if (this.deviceTypeCode.length) {
            this.deviceSelectHistoryData = devices.filter(item => this.deviceTypeCode.includes(item.categoryDictCode)) || [];
          } else {
            this.deviceSelectHistoryData = devices;
          }
        }

        this.timeRangeCfg.enable && (this.timeRange = this.timeRangeCfg.timeRange);
      } else {
        this.deviceName = this.selDeviceName;
        this.deviceId = this.selDeviceId;
        this.deviceSn = this.seldeviceSn;
        this.deviceBrandId = this.seldeviceBrandId;
        this.categoryDictCode = this.selCategoryDictCode;
        this.categoryDictName = this.selCategoryDictName;
      }
    },
    curDeviceList(val) {
      this.filteredDevices = val;
      if (!this.hasInitOrigin && this.originDevice) {
        this.$emit('confirm', { deviceInfo: val.filter(de => de.name === this.originDevice)[0] });
        this.hasInitOrigin = true;
      }
    },
    originDevice(device) {
      // 有初始默认设备选择，查询相关信息
      if (!this.hasInitOrigin && device) {
        this.onSelectGourp({ option: { id: 'cateAllDevice', label: this.$t('全部设备') }});
      }
    },
    deviceCode(val) {
      this.deviceTypeCode = val;
    }
  },
  methods: {
    // 查询类型和区域数据集
    initDeviceList() {
      this.loadingGroup = true;
      axiosAllSettled([
        () => baseDeviceApi.getDeviceAllTypes({ category: this.useNewSelector && !this.newSelectorParams.machine ? '' : 'MACHINE' }),
        () => baseOrgApi.allSpaceTree({ state: true })
      ]).then(([cateDeviceRes, spaceDeviceRes]) => {
        const selectGroupList = [{ group: 'cate', data: [] }, { group: 'space', data: [] }];
        if (cateDeviceRes.isSuccess) {
          if (this.deviceTypeCode.length) {
            const filterList = cateDeviceRes.data.filter(item => {
              if (this.deviceTypeCode.includes(item.code)) {
                return item;
              }
            }) || [];
            selectGroupList[0].data = [{ id: 'cateAllDevice', label: this.$t('全部设备') }, ...filterList.map(item => ({ ...item, label: item.name }))];
          } else {
            selectGroupList[0].data = [{ id: 'cateAllDevice', label: this.$t('全部设备') }, ...cateDeviceRes.data.map(item => ({ ...item, label: item.name }))];
          }
        }

        if (spaceDeviceRes.isSuccess) {
          selectGroupList[1].data = [{ id: 'spaceAllDevice', label: this.$t('全部设备') }, ...spaceDeviceRes.data];
        }
        this.selectGroupList = selectGroupList;
        this.$nextTick(() => {
          this.updateSelectWithCache();
        });
      }).finally(() => {
        this.loadingGroup = false;
      });
    },
    // 获取全部设备
    getAllDevices(callback = null, filterCode) {
      if (this.deviceAllData.length) {
        const deviceAll = filterCode ? this.deviceAllData.filter(device => device.categoryDictCode === filterCode) : this.deviceAllData;
        this.curDeviceList = deviceAll.reduce((pre, cur) => pre.concat(cur.children.map(i => ({ ...i, categoryDictName: cur.echoMap.categoryDictCode }))), []);
        callback && this.$nextTick(callback);
        return;
      }

      this.loadingDevice = true;
      const queryDevice = this.useNewSelector ? ccsDeviceApi.getDeviceSimpleInfoBySpaceId : baseDeviceApi.findBySpaceId;

      queryDevice(this.useNewSelector ? this.newSelectorParams : { isOnlyMonitor: this.isOnlyMonitor })
        .then((res) => {
          if (this.deviceTypeCode.length) {
            // 过滤工序设备类型
            const data = (res.data?.data || []).filter(item => {
              if (this.deviceTypeCode.includes(item.categoryDictCode)) {
                return item;
              }
            });
            this.deviceAllData = data;
          } else {
            // 兼容 categoryDictName: i.echoMap.categoryDictCode
            this.deviceAllData = res.data?.data || [];
          }

          const deviceAll = filterCode ? this.deviceAllData.filter(device => device.categoryDictCode === filterCode) : this.deviceAllData;
          this.curDeviceList = deviceAll.reduce((pre, cur) => pre.concat(cur.children.map(i => ({ ...i, categoryDictName: cur.echoMap.categoryDictCode }))), []);
          filterCode && (this.deviceCacheMap[filterCode] = this.curDeviceList);
          callback && this.$nextTick(callback);
        }).finally(_ => {
          this.loadingDevice = false;
        });
    },
    onTabChange(tab) {
      this.activeTab = tab;
      this.selectType = tab === 'space' ? 'tree' : 'list';
      const groupIndex = this.tabsList.findIndex(t => t.name === tab);
      if (this.isUsingCache) {
        this.isUsingCache = false;
        return;
      }
      this.selectedGroupOpt = this.currentSelected[tab] ? [this.currentSelected[tab]] : this.selectGroupList[groupIndex].data.slice(0);
      this.onSelectGourp({ activeTab: tab, option: this.selectedGroupOpt[0] }, () => {
        this.$nextTick(() => {
          this.$refs.groupSelector?.$el?.querySelector('.is-current')?.scrollIntoView();
          this.$refs.deviceScroller?.$el?.querySelector('.device-item-cli')?.scrollIntoView();
        });
      });
    },
    // 左侧查询类型选择
    onSelectGourp({ activeTab = 'cate', option }, callback = null) {
      // 记录类型或区域下当前选择的
      this.currentSelected[activeTab] = JSON.parse(JSON.stringify(option));
      if (option.id === 'cateAllDevice' || option.id === 'spaceAllDevice') {
        this.getAllDevices(callback);
        return;
      }

      const key = activeTab === 'cate' ? option.code : option.id;
      if (this.deviceCacheMap[key]) {
        this.curDeviceList = JSON.parse(JSON.stringify(this.deviceCacheMap[key]));
        callback && this.$nextTick(callback);
        return;
      }

      // 按设备类型
      if (activeTab === 'cate') {
        if (this.useNewSelector) { // 新的设备过滤逻辑（后端），从设备全集里筛选
          this.getAllDevices(callback, option.code);
          this.deviceCacheMap[option.code] = JSON.parse(JSON.stringify(this.curDeviceList));
        } else { // 旧的，按设备类型查询
          this.loadingDevice = true;
          ccsDeviceApi.getDeviceSimpleInfo({
            category: option.code
          }).then(response => {
            const res = response.data;
            if (res.isSuccess) {
              this.curDeviceList = res.data;
              this.deviceCacheMap[option.code] = JSON.parse(JSON.stringify(this.curDeviceList));
              callback && this.$nextTick(callback);
            }
          }).finally(_ => {
            this.loadingDevice = false;
          });
        }
        return;
      }

      // 按区域/空间类型
      this.loadingDevice = true;
      const queryDevice = this.useNewSelector ? ccsDeviceApi.getDeviceSimpleInfoBySpaceId : baseDeviceApi.findBySpaceId;
      queryDevice(this.useNewSelector ? {
        ...this.newSelectorParams,
        spaceId: option.id
      } : {
        spaceId: option.id,
        isOnlyMonitor: this.isOnlyMonitor
      }).then((res) => {
        if (this.deviceTypeCode.length) {
          const data = (res.data?.data || []).filter(item => {
            if (this.deviceTypeCode.includes(item.categoryDictCode)) {
              return item;
            }
          });
          this.curDeviceList = data.reduce((pre, cur) => pre.concat(cur.children.map(i => ({ ...i, categoryDictName: cur.echoMap.categoryDictCode }))), []);
        } else {
          // 兼容 categoryDictName: i.echoMap.categoryDictCode
          this.curDeviceList = (res.data?.data || []).reduce((pre, cur) => pre.concat(cur.children.map(i => ({ ...i, categoryDictName: cur.echoMap.categoryDictCode }))), []);
        }
        this.deviceCacheMap[option.id] = JSON.parse(JSON.stringify(this.curDeviceList));
        callback && this.$nextTick(callback);
      }).finally(_ => {
        this.loadingDevice = false;
      });
    },
    updateSelectWithCache() {
      // 读取上次选择的设备
      if (localStorage.getItem(this.locStorageKey)) {
        const historyData = JSON.parse(localStorage.getItem(this.locStorageKey));
        const devices = historyData.devices || [];
        const lastDevice = {
          id: devices[0].deviceId,
          name: devices[0].deviceName,
          sn: devices[0].sn,
          deviceBrandId: devices[0].deviceBrandId,
          categoryDictCode: devices[0].categoryDictCode,
          categoryDictName: devices[0].categoryDictName,
          spaceName: devices[0].spaceName,
          ...devices[0].deviceInfo
        };

        this.isUsingCache = true;
        this.activeTab = historyData.group;
        this.$refs.groupSelector.activeTab = this.activeTab;
        this.selectedGroupOpt = [historyData.groupOpt];
        this.currentSelected[this.activeTab] = historyData.groupOpt;
        this.onSelectGourp({ activeTab: this.activeTab, option: this.selectedGroupOpt[0] }, () => {
          this.handleDeviceClick(lastDevice);
          this.$nextTick(() => {
            this.$refs.groupSelector?.$el?.querySelector('.is-current')?.scrollIntoView();
            this.$refs.deviceScroller?.$el?.querySelector('.device-item-cli')?.scrollIntoView();
          });
        });
        return;
      } else {
        // 无缓存，开始时类型默认选中全部
        this.selectedGroupOpt = this.selectGroupList[0].data.slice(0);
        this.onSelectGourp({ activeTab: 'cate', option: this.selectedGroupOpt[0] });
      }
    },
    searchDevice() {
      if (this.searchVal) {
        this.filteredDevices = this.curDeviceList.filter(i => i.name.includes(this.searchVal));
      } else {
        this.filteredDevices = this.curDeviceList;
      }
    },
    handleDeviceClick(e) {
      this.isSelectCache = !!e.isCached;
      this.deviceId = e.id;
      this.deviceName = e.name;
      this.deviceSn = e.sn;
      this.deviceBrandId = e.deviceBrandId;
      this.categoryDictCode = e.categoryDictCode;
      this.categoryDictName = e.categoryDictName;
      this.selSpaceName = e.spaceName || this.spaceName;
      this.selSpaceName = e.spaceName;
      this.deviceInfo = JSON.parse(JSON.stringify(e));
      if (this.isSelectCache) {
        this.$nextTick(() => {
          this.$refs.deviceScroller?.$el?.querySelector('.device-item-cli')?.scrollIntoView();
        });
      }
    },
    handleDeviceDblclick(e) {
      this.handleDeviceClick(e);
      this.confirmDevice();
    },
    onTimeShortcutChange() {
      this.$nextTick(() => {
        this.timeRangeCfg.shortcutChange(this.timeRange);
      });
    },
    // 确认选择回调
    confirmDevice() {
      if (!this.deviceId) {
        return this.$message.warning(this.$t('请选择设备'));
      }
      if (this.timeRangeCfg.enable && (!this.timeRange[0] || !this.timeRange[1])) {
        return this.$message.warning(this.$t('请选择查询时间范围'));
      }

      const currentSelectDevice = {
        deviceName: this.deviceName,
        deviceId: this.deviceId,
        sn: this.deviceSn,
        deviceBrandId: this.deviceBrandId,
        categoryDictCode: this.categoryDictCode,
        categoryDictName: this.categoryDictName,
        spaceName: this.selSpaceName,
        deviceInfo: this.deviceInfo
      };
      let devices = [];
      // 如果快速选择中不存在这个设备，则存到localStorage中
      if (!(JSON.parse(localStorage.getItem(this.locStorageKey))?.devices || []).some(v => v.deviceId === this.deviceId)) {
        devices = [
          currentSelectDevice,
          ...(JSON.parse(localStorage.getItem(this.locStorageKey))?.devices || [])
        ].slice(0, 5);

        if (this.deviceTypeCode.length) {
        // 过滤工序设备类型
          let data = [];
          data = this.deviceSelectHistoryData.filter(item => {
            if (this.deviceTypeCode.includes(item.categoryDictCode)) {
              return item;
            }
          }) || [];
          this.deviceSelectHistoryData = data;
        }
      } else {
        devices = [
          currentSelectDevice,
          ...((JSON.parse(localStorage.getItem(this.locStorageKey))?.devices || []).filter(v => v.deviceId !== this.deviceId))
        ].slice(0, 5);
      }

      localStorage.setItem(this.locStorageKey, JSON.stringify({
        group: this.isSelectCache ? 'cate' : this.activeTab,
        groupOpt: this.isSelectCache ? this.selectGroupList[0].data[0] : this.currentSelected[this.activeTab],
        devices
      }));

      this.selDeviceName = this.deviceName;
      this.selDeviceId = this.deviceId;
      this.seldeviceSn = this.deviceSn;
      this.seldeviceBrandId = this.deviceBrandId;
      this.selCategoryDictCode = this.categoryDictCode;
      this.selCategoryDictName = this.categoryDictName;

      this.$emit('confirm', {
        deviceName: this.deviceName,
        deviceId: this.deviceId,
        deviceSn: this.deviceSn,
        deviceBrandId: this.deviceBrandId,
        categoryDictCode: this.categoryDictCode,
        categoryDictName: this.categoryDictName,
        spaceName: this.selSpaceName,
        deviceInfo: this.deviceInfo,
        timeRange: this.timeRange
      });
      this.$emit('update:visible', false);
    },
    // 取消选择设备
    cancleDevice() {
      this.timeRangeCfg.change && this.timeRangeCfg.change(this.timeRangeCfg.timeRange[0], 'begin');
      this.timeRangeCfg.change && this.timeRangeCfg.change(this.timeRangeCfg.timeRange[1], 'end');
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang='scss' scoped>
::v-deep .ku-dialog {
  max-height: 750px;
  .dialog__main {
    padding: 24px 0px 16px 0px !important;
    border-bottom: 1px solid #E5E6EB;
  }
}
.device-selector {
  height: 50vh;
  margin: 0 16px 0 24px;
  .left_block {
    width: 220px;
    height: 100%;
    .ku-vertical-selector {
      width: 100% !important;
      height: 100%;
      ::v-deep .icon-s-chejian {
        color: #3A71FF;
      }
    }
  }
  .midddle-block {
    flex: 1;
    padding: 16px 0 8px 0;
    border: 1px solid #E5E6EB;
    border-left: none;
    display: flex;
    flex-direction: column;
    &_search {
      width: 100%;
      margin-bottom: 16px;
      padding: 0 16px;
      .ku-input {
        width: 100%;
      }
    }
    &_area {
      height: 100%;
      margin: 0 2px;
      ::v-deep {
        .el-scrollbar__wrap {
          padding: 0 14px;
          overflow-x: hidden;
        }
      }
      .device-box {
        flex-wrap: wrap;
        .device-item {
          border-radius: 20px;
          background-color: #F7F8FA;
          width: calc(50% - 4px);
          margin-bottom: 8px;
          padding: 8px 12px;
          line-height: 22px;
          cursor: pointer;
          &:nth-child(2n) {
            margin-left: 8px;
          }
          &:hover {
            background-color: #e8f2ff;
            color: #3a71ff;
          }
          &.device-item-cli {
            border:1px solid #3A71FF;
            background-color: #e8f2ff;
            color: #3a71ff;
            padding: 7px 11px;
          }
          &:not(.device-showstatus) {
            padding-left: 16px;
          }
        }
      }
    }
  }
  .right_block {
    width: 190px;
    border: 1px solid #E5E6EB;
    border-left: none;
    display: flex;
    flex-direction: column;
    &_title {
      margin: 16px 16px 12px 16px;
      line-height: 22px;
      color: #1D2129;
    }
    ::v-deep {
      .el-scrollbar {
        flex: 1;
        &__wrap {
          overflow-x: hidden;
        }
        &__view {
          display: flex;
          flex-direction: column;
          padding: 0 16px;
        }
      }
    }
    .device-label{
      background: #F0F1F2;
      border-radius: 2px;
      padding: 4px 8px;
      cursor: pointer;
      color: #4E5969;
      line-height: 20px;
      &:not(:first-child) {
        margin-top: 12px;
      }
      &.active{
        background: #E6EDFF;
        color: #3A71FF;
      }
    }
  }
}
.expand_block {
  border-top: 1px solid #E5E6EB;
  padding: 8px 16px 0px 16px;
  margin-top: 24px;
  .ku-form {
    width: 50%;
  }
  ::v-deep {
    .ku-datetime-picker--shortcut_popper {
      right: auto !important;
      position: fixed !important;
    }
  }
}
</style>
